<!-- Existing Tag Selctor -->
<yc-typeahead-select *ngIf="!addingTag"
  name="tags"
  [items]="availableTags"
  [multi]="true"
  [useLabelTemplate]="false"
  [srOnlyLabel]="!showLabel"
  [label]="'GLOBAL:lblTags' | ycI18n"
  [placeholder]="'tags:linkSelectTags' | ycI18n: 'Select tags'"
  [help]="showHelp ? ('tags:textTagsHelp' | ycI18n: 'Tags can be used to aid in filtering and reporting') : ''"
  (onChange)="onChange.emit($event)">
</yc-typeahead-select>

<!-- Add New Tag Input -->
<div *ngIf="addingTag">

  <!-- Tag Name -->
  <div class="d-flex align-items-center">
    <yc-input
      class="flex-grow-1"
      [placeholder]="'common:textNewTagPlacehlder' | ycI18n: 'Enter the name of your new tag and choose the bucket it will belong to'"
      name="newTagName"
      [label]="'GLOBAL:textNewTagName' | ycI18n: 'New tag name'">
    </yc-input>

    <!-- Save New Tag -->
    <yc-button *ngIf="formGroup.value.newTagName"
      class="ms-2 mt-3"
      [icon]="true"
      [tooltipText]="'common:btnSave' | ycI18n: 'Save'"
      (onClick)="onSaveNewTag()">
      <yc-fa
        icon="check"
        class="text-success">
      </yc-fa>
    </yc-button>
    <!-- Clear New Tag -->
    <yc-button
      class="ms-2 mt-3"
      [icon]="true"
      [tooltipText]="'common:textRemove' | ycI18n: 'Remove'"
      (onClick)="onClearAddTag()">
      <yc-fa
        icon="times"
        class="text-danger">
      </yc-fa>
    </yc-button>
  </div>

  <!-- Bucket -->
  <yc-typeahead-select
    name="bucket"
    [value]="addToBucketId"
    [label]="'common:textBucketForNewTag' | ycI18n: 'Bucket for new tag'"
    [items]="bucketOptions"
    (valueChange)="bucketChange($event)">
  </yc-typeahead-select>
</div>


<!-- Add New Tag Action -->
<div *ngIf="!addingTag && canCreateTags"
  class="d-flex justify-content-end">
  <yc-button
    [link]="true"
    [langKey]="'GLOBAL:textCreateNewTag'"
    [defaultText]="'Create new tag'"
    (onClick)="onAddTag()">
  </yc-button>
</div>